import {
  Mail02Icon,
  SmartPhone01Icon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Avatar } from "shared/components/Avatar";
import { formatPhone } from "shared/utils";
import { Property } from "types/landlord/address";

type Branding = NonNullable<Property["branding"]>;

const getLogoUrl = (logo: Branding["logo"]) =>
  typeof logo === "string" ? logo : logo?.asset?.url;

export const BrandingToApplyPreview = ({
  branding,
  showLandlordFields
}: {
  branding: Branding;
  showLandlordFields: boolean;
}) => {
  const logoUrl = getLogoUrl(branding.logo);
  const title = showLandlordFields
    ? branding.landlord_name || "No landlord name set"
    : branding.primary_color || "No primary color set";
  const contacts = (
    showLandlordFields
      ? [
          {
            key: "phone",
            icon: SmartPhone01Icon,
            value: branding.landlord_phone
              ? formatPhone(branding.landlord_phone)
              : ""
          },
          {
            key: "email",
            icon: Mail02Icon,
            value: branding.landlord_email || ""
          }
        ]
      : []
  ).filter((contact) => Boolean(contact.value));

  return (
    <div className="space-y-2">
      <p className="text-xs font-medium text-content-400">Branding to apply</p>
      <div className="rounded-lg bg-background-900 p-4">
        <div className="flex items-center gap-4">
          {branding.primary_color ? (
            <Avatar
              fallbackBackgroundColor={branding.primary_color}
              fallbackText=""
              shape="circle"
              size={20}
            />
          ) : null}
          <p className="grow truncate text-sm font-medium text-content-1000">
            {title}
          </p>
          {logoUrl ? (
            <img
              alt=""
              className="h-5 max-w-[120px] shrink-0 object-contain"
              src={logoUrl}
            />
          ) : null}
        </div>

        {contacts.length > 0 ? (
          <div className="mt-3 flex items-center gap-3 border-t border-alpha-40 pt-3">
            {contacts.map((contact) => (
              <p
                className="flex min-w-0 items-center gap-2 text-sm text-content-400"
                key={contact.key}
              >
                <HugeiconsIcon
                  className="shrink-0 text-content-400"
                  icon={contact.icon}
                  size={20}
                />
                <span className="truncate">{contact.value}</span>
              </p>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};
